/* Classic Collection - product page extras (ADD-ONLY: does not change the existing layout or buttons)
 *  1. Estimated delivery date range (Asia/Karachi, skips Sundays + listed holidays, optional daily cut-off)
 *  2. Engraving field helper: character counter, optional font choice, live preview (spelling check)
 *  3. Sticky "Order Now" bar on mobile (clicks the EXISTING order button)
 *  4. Optional "Add gift box" toggle (separate cart line using a real gift-box variant)
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.CCExtras = api;
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', api.boot);
    else api.boot();
  }
})(this, function () {
  'use strict';

  /* ---------- 1. delivery estimate (pure, unit-tested) ---------- */
  function pktParts(date) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Karachi', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(date);
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function addDays(d, n) { return new Date(d.getTime() + n * 86400000); }
  function isWorking(d, holidays) { return d.getUTCDay() !== 0 && !holidays[iso(d)]; }
  function nextWorking(d, holidays) { while (!isWorking(d, holidays)) d = addDays(d, 1); return d; }
  function addWorking(d, n, holidays) {
    var c = 0;
    while (c < n) { d = addDays(d, 1); if (isWorking(d, holidays)) c++; }
    return d;
  }
  // opts: { min, max, cutoffHour (24 = no cut-off), holidays: ['YYYY-MM-DD'] }
  function estimateDelivery(now, opts) {
    var holidays = {};
    (opts.holidays || []).forEach(function (h) { if (h) holidays[h.trim()] = true; });
    var p = pktParts(now);
    var today = new Date(Date.UTC(p.y, p.m - 1, p.d));
    var base = today;
    if (!isWorking(today, holidays) || p.h >= (opts.cutoffHour == null ? 24 : opts.cutoffHour)) {
      base = nextWorking(addDays(today, 1), holidays);
    }
    return { from: addWorking(base, opts.min, holidays), to: addWorking(base, opts.max, holidays), confirmedToday: base.getTime() === today.getTime() };
  }
  function fmtDate(d) {
    return new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(d);
  }

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function safe(fn, fb) { try { return fn(); } catch (e) { return fb; } }
  function intAttr(el, name, d) { var n = parseInt(el.getAttribute(name), 10); return isFinite(n) ? n : d; }

  function initDelivery(box) {
    var target = $('[data-cc-delivery-text]', box);
    if (!target) return;
    var est = estimateDelivery(new Date(), {
      min: intAttr(box, 'data-min', 4), max: intAttr(box, 'data-max', 5),
      cutoffHour: intAttr(box, 'data-cutoff', 24),
      holidays: (box.getAttribute('data-holidays') || '').split(',')
    });
    var range = fmtDate(est.from) + ' – ' + fmtDate(est.to);
    target.textContent = (est.confirmedToday ? 'If you confirm your details today, estimated delivery: ' : 'If you confirm your details by the next working day, estimated delivery: ') + range;
    box.hidden = false;
  }

  /* ---------- 2. engraving helper ---------- */
  function findEngravingInput(selector) {
    if (selector) { var s = $(selector); if (s) return s; }
    var all = $$('input[name^="properties["], textarea[name^="properties["]').filter(function (el) {
      return el.type !== 'hidden' && el.type !== 'file' && el.type !== 'checkbox' && el.type !== 'radio';
    });
    var best = all.filter(function (el) {
      var label = el.id ? $('label[for="' + el.id + '"]') : null;
      return /engrav|custom|name|text/i.test(el.name + ' ' + (label ? label.textContent : '') + ' ' + (el.placeholder || ''));
    })[0];
    return best || all[0] || null;
  }

  function initEngraving(box) {
    var input = findEngravingInput(box.getAttribute('data-input-selector'));
    if (!input) return;
    var max = intAttr(box, 'data-max', 20);
    if (max > 0) input.setAttribute('maxlength', String(max));
    var counter = $('[data-cc-engraving-count]', box);
    var preview = $('[data-cc-preview-text]', box);
    var select = $('[data-cc-font-select]', box);
    var fonts = safe(function () { return JSON.parse(box.getAttribute('data-fonts') || '[]'); }, []);
    var form = input.form || $('form[action*="/cart/add"]');
    var hidden = null;

    if (fonts.length && select && form) {
      fonts.forEach(function (f, i) {
        var opt = document.createElement('option');
        opt.value = f.value || f.label; opt.textContent = f.label; opt.setAttribute('data-css', f.css || '');
        if (i === 0) opt.selected = true;
        select.appendChild(opt);
      });
      hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'properties[Engraving font]'; hidden.value = fonts[0].value || fonts[0].label;
      form.appendChild(hidden);
      select.closest('[data-cc-font-wrap]').hidden = false;
    }

    function render() {
      var v = input.value || '';
      if (counter && max > 0) counter.textContent = v.length + '/' + max;
      if (preview) {
        preview.textContent = v || preview.getAttribute('data-placeholder') || '';
        preview.classList.toggle('is-empty', !v);
        if (select && select.selectedOptions && select.selectedOptions[0]) {
          preview.style.fontFamily = select.selectedOptions[0].getAttribute('data-css') || '';
        }
      }
      if (hidden && select) hidden.value = select.value;
    }
    input.addEventListener('input', render);
    if (select) select.addEventListener('change', render);
    render();
    box.hidden = false;
    box.__ccInput = input;
  }

  /* ---------- 3. sticky order bar ---------- */
  function findBuyButton(bar) {
    var sel = bar.getAttribute('data-order-selector');
    if (sel) { var s = $(sel); if (s) return s; }
    // never pick the sticky bar's own button
    var candidates = $$('form[action*="/cart/add"] button, form[action*="/cart/add"] input[type="submit"], form[action*="/cart/add"] a, button, a.button')
      .filter(function (el) { return !bar.contains(el); });
    var byText = candidates.filter(function (el) { return /order\s*now/i.test(el.textContent || el.value || ''); })[0];
    return byText || $('form[action*="/cart/add"] [type="submit"]') || null;
  }

  function initSticky(bar, engravingBox) {
    var buy = findBuyButton(bar);
    if (!buy) return;
    var btn = $('[data-cc-sticky-btn]', bar);
    var priceEl = $('[data-cc-sticky-price]', bar);
    var priceSource = $(bar.getAttribute('data-price-selector') || '.price-item--last, .price__current, [data-product-price], .price .money, .price');
    var soldOutLabel = bar.getAttribute('data-soldout-label') || 'Sold out';
    var orderLabel = bar.getAttribute('data-order-label') || 'Order Now';
    var shown = false;

    function setVar(px) { document.documentElement.style.setProperty('--cc-sticky-h', px + 'px'); }
    function syncPrice() { if (priceEl && priceSource) priceEl.textContent = (priceSource.textContent || '').replace(/\s+/g, ' ').trim(); }
    function syncState() {
      var dead = buy.disabled || buy.getAttribute('aria-disabled') === 'true';
      btn.disabled = dead;
      btn.textContent = dead ? soldOutLabel : orderLabel;
    }
    function show(flag) {
      if (flag === shown) return;
      shown = flag;
      bar.hidden = !flag;
      bar.classList.toggle('is-visible', flag);
      document.body.classList.toggle('cc-has-sticky', flag);
      setVar(flag ? bar.offsetHeight : 0);
      if (flag) { syncPrice(); syncState(); }
    }

    btn.addEventListener('click', function () {
      var input = engravingBox && engravingBox.__ccInput;
      var needs = input && (input.required || bar.getAttribute('data-require-engraving') === 'true') && !input.value.trim();
      if (needs) {
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
        input.classList.add('cc-nudge');
        setTimeout(function () { input.classList.remove('cc-nudge'); }, 1200);
        return;
      }
      buy.click();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        show(!visible && window.scrollY > 200);
      }, { threshold: 0.01 }).observe(buy);
      window.addEventListener('scroll', function () { if (shown && window.scrollY <= 200) show(false); }, { passive: true });
    }
    document.addEventListener('change', function () { if (shown) { syncPrice(); syncState(); } });
  }

  /* ---------- 4. gift box toggle ---------- */
  function initGiftBox(box) {
    var variant = box.getAttribute('data-variant-id');
    var btn = $('[data-cc-giftbox-btn]', box);
    if (!variant || !btn) return;
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var label = $('[data-cc-giftbox-label]', box);
    var on = false;
    function paint(msg) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
      if (label) label.textContent = msg || (on ? 'Gift box added ✓ (tap to remove)' : box.getAttribute('data-label'));
    }
    fetch(rootUrl + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      on = cart.items.some(function (i) { return String(i.variant_id) === String(variant); });
      paint(); box.hidden = false;
    }).catch(function () { paint(); box.hidden = false; });

    btn.addEventListener('click', function () {
      btn.disabled = true;
      var req = on
        ? fetch(rootUrl + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(variant), quantity: 0 }) })
        : fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] }) });
      req.then(function (r) { if (!r.ok) throw new Error('cart'); on = !on; paint(); })
        .catch(function () { paint('Could not update the gift box. Please try again.'); })
        .then(function () { btn.disabled = false; });
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    var delivery = $('[data-cc-delivery]'); if (delivery) initDelivery(delivery);
    var engraving = $('[data-cc-engraving]'); if (engraving) initEngraving(engraving);
    var sticky = $('[data-cc-sticky]'); if (sticky) initSticky(sticky, engraving);
    var gift = $('[data-cc-giftbox]'); if (gift) initGiftBox(gift);
  }

  return { estimateDelivery: estimateDelivery, fmtDate: fmtDate, findEngravingInput: findEngravingInput, boot: boot };
});
